import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useNavigate } from 'react-router-dom';

const goToForm = (navigate: ReturnType<typeof useNavigate>) => {
  navigate('/');
  setTimeout(() => {
    const el = document.getElementById('contact-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, 300);
};

export default function About() {
  const navigate = useNavigate();

  const handleCTA = () => goToForm(navigate);

  useEffect(() => {
    document.title = '關於全鏈行銷 - 企業 O2O 數位轉型顧問 | 全鏈獲客戰略夥伴';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', '全鏈行銷專精企業 O2O 整合系統建置與頂級全鏈獲客代操，將混亂的傳統管理升級成全自動化的獲客雷達，為企業主打造從內部防呆到全鏈路廣告的數位轉型閉環。');
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`);

    const scriptId = 'jsonld-about';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify([
        {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首頁', item: import.meta.env.VITE_SITE_URL || 'https://example.com' },
            { '@type': 'ListItem', position: 2, name: '關於全鏈行銷', item: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about` },
          ],
        },
        {
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about#webpage`,
          url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
          name: '關於全鏈行銷 - 企業 O2O 數位轉型顧問',
          description: '全鏈行銷：您的企業數位轉型顧問與獲客戰友。',
          inLanguage: 'zh-TW',
          isPartOf: {
            '@type': 'WebSite',
            name: '全鏈行銷',
            url: import.meta.env.VITE_SITE_URL || 'https://example.com',
          },
          about: {
            '@type': 'Organization',
            name: '全鏈行銷',
            description: '專精企業 O2O 整合系統建置與頂級全鏈獲客代操。',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              availableLanguage: 'zh-TW',
            },
          },
        },
      ]);
      document.head.appendChild(script);
    }
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <>
      <Navbar onConsultClick={handleCTA} />
      <div className="pt-20">
        {/* Hero 區 */}
        <section className="relative bg-[#0A192F] py-32 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/5e8bf5e691005020a6ff877546e5ec10.jpg"
              alt="全鏈行銷顧問會議"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/95 via-[#0A192F]/75 to-[#0A192F]/40"></div>
          </div>
          {/* 背景光暈 */}
          <div className="absolute top-20 left-20 w-80 h-80 bg-[#D4AF37]/10 rounded-full blur-3xl pointer-events-none"></div>
          <div className="relative z-10 max-w-7xl mx-auto px-6">
            <div className="max-w-3xl">
              <div className="inline-flex items-center gap-2 bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] px-5 py-2 rounded-full text-sm font-semibold mb-7">
                <i className="ri-shield-star-fill text-base"></i>
                關於全鏈行銷
              </div>
              <h1 className="text-4xl sm:text-5xl font-bold text-white leading-tight mb-5">
                全鏈獲客：您的企業
                <span className="block mt-2 bg-gradient-to-r from-[#D4AF37] to-[#F0C040] bg-clip-text text-transparent">
                  數位轉型顧問與獲客戰友
                </span>
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed mb-8">
                全鏈行銷專精：將混亂的傳統管理，升級成<strong className="text-[#D4AF37]">全自動化的獲客雷達</strong>
              </p>
              <button
                onClick={handleCTA}
                className="bg-gradient-to-r from-[#D4AF37] to-[#F0C040] text-[#060F1E] px-10 py-4 rounded-full text-lg font-bold hover:shadow-[0_4px_30px_rgba(212,175,55,0.5)] transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                預約免費系統展示
              </button>
            </div>
          </div>
        </section>

        {/* 我們的使命 */}
        <section className="bg-[#060F1E] py-24">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <div className="inline-flex items-center gap-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37] px-5 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-flag-line text-base"></i>
                我們的使命
              </div>
              <h2 className="text-4xl font-bold text-white mb-6">
                讓每間企業都能擁有<br />
                <span className="bg-gradient-to-r from-[#D4AF37] to-[#F0C040] bg-clip-text text-transparent">企業級的數位管理與獲客能力</span>
              </h2>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="bg-gradient-to-br from-[#0F2744] to-[#0D1A2A] p-10 rounded-2xl border border-[#D4AF37]/20">
                <p className="text-gray-300 text-lg leading-relaxed mb-5">
                  在台灣，許多高價值產業的管理仍停留在紙本紀錄與個人手機群組，
                  導致<strong className="text-[#D4AF37]">名單漏報、數據斷層、廣告預算打水漂</strong>等問題，日復一日消耗著老闆的精力與金錢。
                </p>
                <p className="text-gray-300 text-lg leading-relaxed mb-5">
                  <strong className="text-white">全鏈行銷</strong>的核心使命，是為企業打造專屬的
                  <strong className="text-[#D4AF37]">【O2O 整合管理 + 全網精準獲客系統】</strong>。
                  我們不賣套版工具，我們建置的是一套能夠<strong className="text-[#D4AF37]">「讓企業自動運轉」</strong>的數位資產。
                </p>
                <p className="text-gray-300 text-lg leading-relaxed">
                  從內部防呆管理到精準廣告打擊，我們用 B2B 級的技術視野，
                  打造<strong className="text-white text-xl">企業專屬的 O2O 數位自動印鈔機</strong>。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 為什麼選擇全鏈行銷 */}
        <section className="bg-[#0A192F] py-24">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-14">
              <div className="inline-flex items-center gap-2 bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] px-5 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-shield-star-line text-base"></i>
                為什麼選擇全鏈行銷
              </div>
              <h2 className="text-4xl font-bold text-white mb-4">
                我們與一般廣告代操的差異
              </h2>
              <p className="text-gray-400 text-lg max-w-2xl mx-auto">
                我們不只代操廣告，我們從內部管理到外部獲客，全鏈路一手包辦
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {[
                {
                  icon: 'ri-settings-4-line',
                  color: 'from-[#D4AF37] to-[#F0C040]',
                  accent: 'text-[#D4AF37]',
                  title: '系統 + 廣告雙軌並進',
                  desc: '一般代操只管廣告投放，全鏈行銷同時建置內部管理系統，讓廣告帶進來的客戶能被完整追蹤、高效成交，形成真正的閉環。',
                },
                {
                  icon: 'ri-shield-check-line',
                  color: 'from-[#00D4FF] to-[#0099CC]',
                  accent: 'text-[#00D4FF]',
                  title: '廣告合規把關先行',
                  desc: '高客單價商業廣告受嚴格平台政策限制，我們主動審查廣告政策，大幅降低帳號停權風險，確保廣告持續安全運作。',
                },
                {
                  icon: 'ri-bar-chart-grouped-line',
                  color: 'from-[#D4AF37] to-[#F0C040]',
                  accent: 'text-[#D4AF37]',
                  title: '全鏈路數據可視化',
                  desc: '從廣告曝光到最終成交，每一個環節都有數據追蹤。每月提供完整的戰略報表，讓老闆清楚每一分廣告預算的投報效益。',
                },
              ].map((item, idx) => (
                <div key={idx} className="bg-[#0F2744] border border-[#1E3A5A] p-8 rounded-2xl hover:border-[#D4AF37]/30 transition-all">
                  <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-xl flex items-center justify-center mb-6`}>
                    <i className={`${item.icon} text-3xl text-white`}></i>
                  </div>
                  <h3 className={`text-xl font-bold mb-4 ${item.accent}`}>{item.title}</h3>
                  <p className="text-gray-400 leading-relaxed text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 核心價值 */}
        <section className="bg-[#060F1E] py-24">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-flex items-center gap-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 text-[#D4AF37] px-5 py-2 rounded-full text-sm font-semibold mb-6">
                  <i className="ri-heart-line text-base"></i>
                  全鏈行銷核心價值
                </div>
                <h2 className="text-3xl sm:text-4xl font-bold text-white leading-tight mb-6">
                  我們不是外包商，
                  <span className="block mt-2 bg-gradient-to-r from-[#D4AF37] to-[#F0C040] bg-clip-text text-transparent">
                    我們是您的數位戰隊
                  </span>
                </h2>
                <p className="text-gray-400 leading-relaxed mb-5">
                  市面上有很多廣告代操公司，每個月給你一張報表、幾張貼文，然後月底收費。
                  他們的 KPI 是「廣告花完」，不是「企業成交」。
                </p>
                <p className="text-gray-300 leading-relaxed mb-5">
                  全鏈行銷的運作邏輯不同。我們以<strong className="text-[#D4AF37]">企業主的視角</strong>思考每一個決策，
                  從系統架構、廣告合規到轉換優化，每一步都對準一個目標：
                  <strong className="text-white">讓您的企業獲取更多高價值訂單、大幅降低管理成本。</strong>
                </p>
                <p className="text-gray-400 leading-relaxed">
                  我們限制每月合作名額，確保每一位客戶都能獲得真正有深度的顧問服務，而非流水線式的廣告代操。
                </p>
              </div>
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20business%20consultant%20team%20working%20on%20automotive%20dealership%20digital%20transformation%20project%20around%20a%20dark%20conference%20table%20with%20multiple%20screens%20showing%20data%20dashboards%20and%20car%20inventory%20systems%20high-end%20corporate%20office%20environment%20with%20dark%20walls%20and%20accent%20lighting%20modern%20sleek%20interior%20design%20professional%20photography%20serious%20business%20atmosphere%20collaboration&width=600&height=500&seq=about-value-blackshield-003&orientation=landscape"
                  alt="全鏈行銷顧問團隊"
                  className="w-full h-72 object-cover object-top rounded-2xl border border-[#D4AF37]/20"
                />
                <div className="absolute -bottom-4 -right-4 bg-[#0F2744] border border-[#D4AF37]/40 rounded-xl p-5 shadow-lg">
                  <div className="text-[#D4AF37] text-3xl font-bold">10 組</div>
                  <div className="text-gray-400 text-sm mt-1">每月限額名額</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 合作須知 */}
        <section className="bg-[#0A192F] py-16">
          <div className="max-w-6xl mx-auto px-6">
            <div className="bg-[#0F2744]/60 border border-[#1E3A5A] p-10 rounded-2xl">
              <h3 className="text-base font-bold text-gray-400 mb-6 flex items-center gap-3">
                <i className="ri-information-line text-[#00D4FF]"></i>
                合作須知與風險提示
              </h3>

              <div className="space-y-5">
                {[
                  { icon: 'ri-alert-line', title: '非保證獲利聲明', desc: '全鏈行銷提供之系統建置與廣告代操服務旨在優化管理效率與引流品質，最終成交結果仍取決於企業商品競爭力、市場環境及業務執行，本公司不保證任何形式的具體獲利或銷售額。' },
                  { icon: 'ri-time-line', title: '廣告平台政策時效性', desc: '廣告平台演算法與合規政策具有不可控之變動性，我們的合規審查建議基於現行平台政策，過往成效不代表未來績效之保證。' },
                  { icon: 'ri-file-shield-line', title: '資訊真實性義務', desc: '客戶須確保提供之車輛資訊與廣告素材符合法規且具真實性，若因虛假陳述導致之法律責任由客戶方自行承擔。' },
                ].map((item, idx) => (
                  <div key={idx}>
                    <h4 className="font-bold text-gray-500 mb-2 flex items-start gap-2 text-xs">
                      <i className={`${item.icon} text-[#00D4FF] mt-0.5`}></i>
                      {item.title}
                    </h4>
                    <p className="text-gray-500 text-xs leading-relaxed pl-5">{item.desc}</p>
                  </div>
                ))}
              </div>

              <div className="mt-8 pt-6 border-t border-[#1E3A5A] text-center">
                <p className="text-gray-600 text-xs">本聲明為保障雙方權益而設，實際合作細節以正式合約為準。</p>
              </div>
            </div>
          </div>
        </section>

        {/* 底部行動呼籲 */}
        <section className="bg-gradient-to-r from-[#060F1E] via-[#0F2744] to-[#060F1E] py-20 border-t border-[#D4AF37]/20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
              準備好啟動您的專屬獲客引擎了嗎？
            </h2>
            <p className="text-gray-400 text-lg mb-10 max-w-2xl mx-auto">
              每月限額 10 組企業，預約全鏈行銷免費數位診斷，親眼看見您企業的數位轉型藍圖。
            </p>
            <button
              onClick={handleCTA}
              className="bg-gradient-to-r from-[#D4AF37] to-[#F0C040] text-[#060F1E] px-14 py-4 rounded-full text-xl font-bold hover:shadow-[0_0_40px_rgba(212,175,55,0.5)] transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              預約免費系統展示
            </button>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}
